import { DESCRICAO_MAX_LENGTH, OBSERVACOES_MAX_LENGTH } from "./nova-obra.types";
import type { DadosObraEtapa1, ErrosEtapaObra } from "./nova-obra.types";

export const CAMPO_OBRIGATORIO_MESSAGE = "Campo obrigatório.";
export const limiteCaracteresMessage = (max: number) => `Máximo de ${max} caracteres.`;

/**
 * Validação da Etapa 1 (RN08/AC10). Local Planejado é opcional; o FEL-0 automático
 * conta como preenchido mesmo desabilitado (`statusFinanceiro` já vem FEL_0).
 */
export function validateEtapaObra(obra: DadosObraEtapa1): ErrosEtapaObra {
  const errors: ErrosEtapaObra = {};

  if (!obra.embarcacaoId) errors.embarcacaoId = CAMPO_OBRIGATORIO_MESSAGE;
  if (!obra.statusObraId) errors.statusObraId = CAMPO_OBRIGATORIO_MESSAGE;
  if (!obra.statusFinanceiro) errors.statusFinanceiro = CAMPO_OBRIGATORIO_MESSAGE;

  if (!obra.descricao.trim()) {
    errors.descricao = CAMPO_OBRIGATORIO_MESSAGE;
  } else if (obra.descricao.length > DESCRICAO_MAX_LENGTH) {
    errors.descricao = limiteCaracteresMessage(DESCRICAO_MAX_LENGTH);
  }

  if (obra.observacoes.length > OBSERVACOES_MAX_LENGTH) {
    errors.observacoes = limiteCaracteresMessage(OBSERVACOES_MAX_LENGTH);
  }

  return errors;
}
